<template>
    <div class="back-button pointer" :class="classes" @click="$emit('click')">
        <a class="btn-back">{{ $t('checkout.title_back') }}</a>
        <slot></slot>
    </div>
</template>

<script>
  export default {
    props: ['classes']
  };
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>
<style scoped>

    .back-button {
        margin-left: 10px;
        margin-bottom: 10px;
        /*    position: absolute;
        bottom: 65px;*/
        display: flex;
        align-items: center;
    }

    .back-button p {
        margin: 0 0 0 10px;
    }

    .btn-back {
        float: left;
        position: relative;
        line-height: 30px;
        width: 50px;
        /*height:30px;*/
        cursor: pointer;
        text-align: center;
        color: #000;
        background: #E7E7E7;
        border-top: solid 1px #ddd;
        border-right: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        font-size: 14px;
        z-index: 1;
        text-decoration: none;
    }

    .btn-back:before {
        position: absolute;
        top: 5.5px;
        left: -6.5px;
        width: 17px;
        height: 18px;
        background: #E7E7E7;
        border-left: solid 1px #ddd;
        border-top: solid 1px #ddd;
        transform: rotate(-45deg) skewX(-10deg) skewY(-10deg);
        -webkit-transform: rotate(-45deg) skewX(-10deg) skewY(-10deg);
        content: "";
        z-index: -1;
    }
</style>



// WEBPACK FOOTER //
// back-button.vue?01b5aa33